import "./svg/fish.svg"

export default {
    name: "fish",
    viewBox: "0 0 32 32",
}
